import store from '@/store'
import { initialConfig } from '@/utils/initialConfig'

const initialTheme = () => {
  return store.state.theme.theme
}

const nullTheme = {
  label: 'Default',
  config: initialConfig(),
  theme: initialTheme(),
  style: ''
}

export default nullTheme
